import {
  teacherSearchParamsMocks,
  teacherSearchResponseMock,
} from "@/users/v3/useTeacherSearchQuery/useTeacherSearchQuery.mock";
import { userSchoolFilterMock, userSchoolResponseMock } from "./userSchoolMock";
import { featureMock } from "./featureMock";
import {
  rosterClassroomFilterMock,
  rosterClassroomResponseMock,
} from "./rosterClassroomMock";
import { teacherThroughUserMock } from "./teacherThroughUserMock";
import { userExperimentResponseMock } from "./userExperiment";
import { personalPageMock, personalPageFilterMock } from "./personalPageMock";
import {
  schoolThroughUserFilterMock,
  schoolThroughUserResponseMock,
} from "./schoolThroughUserMock";
import { searchFilterMock, searchMock } from "./search";
import { eventRecordMock } from "./eventRecordMock";
import {
  recommendationsMock,
  recommendationsFilterMock,
} from "./recommendationsMock";
import { schoolRecommendationMock } from "./schoolRecommendationMock";
import { teacherPostPayloadMock } from "./teacherMock";
import { mockContentDelivery } from "./standardsSets";
import {
  promotedContentMock,
  promotedContentFilterMock,
} from "./promotedContentMock";
import { singleContentMock } from "./singleContentMock";
import { searchInterpretMock } from "./searchInterpret";
import { trafficCopMock } from "./trafficCop";

// TODO use satisfies to restrict keys here in the future.
// TODO rename to something like `getMocks`, meaning that the data bellow is
// what is returned from a GET request
export const endpointMock = {
  feature: featureMock,
  teacherThroughUser: teacherThroughUserMock,
  eventRecord: eventRecordMock,
  rosterClassroom: rosterClassroomResponseMock,
  personalPage: personalPageMock,
  recommendations: recommendationsMock,
  schoolRecommendation: schoolRecommendationMock,
  schoolThroughUser: schoolThroughUserResponseMock,
  search: searchMock,
  searchIntepret: searchInterpretMock,
  userSchool: userSchoolResponseMock,
  userExperiment: userExperimentResponseMock,
  teacherThroughSchool: teacherSearchResponseMock,
  contentDelivery: mockContentDelivery,
  promotedContent: promotedContentMock,
  singleContent: singleContentMock,
  trafficCop: trafficCopMock,
} as const;

export const postPayloadMock = {
  teacher: teacherPostPayloadMock,
} as const;

export const queryMocks = {
  rosterClassroom: rosterClassroomFilterMock,
  personalPage: personalPageFilterMock,
  recommendations: recommendationsFilterMock,
  promotedContent: promotedContentFilterMock,
  schoolThroughUser: schoolThroughUserFilterMock,
  search: searchFilterMock,
  userSchool: userSchoolFilterMock,
  teacherThroughSchool: teacherSearchParamsMocks,
} as const;

export default endpointMock;
